import { downloadBlobFromResponse } from "~/common/utils/ApiHelper";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import type { PreviewData } from "../types/models";
import { transformPreviewItem } from "../utils/transformers";
import type { PreviewDataDTO } from "../types/dtos";

export interface Result {
  data: PreviewData;
  error?: string;
}

const apiUrl = occUrl("/quote/split/upload");

export const downloadQuotationSplitTemplate = async (): Promise<void> => {
  const response = await occFetch(occUrl("/quote/split/template"));
  if (!response.ok) {
    throw new Error(`Failed to download quotation split template: ${response.status}`);
  }
  await downloadBlobFromResponse(response);
};

export const sendQuoteForValidation = async (file: File, signal?: AbortSignal): Promise<Result> => {
  const data = new FormData();
  data.append("file", file);

  const params: RequestInit = {
    body: data,
    cache: "no-cache",
    method: "POST",
    mode: "cors",
    redirect: "follow",
    signal,
  };

  const res = await occFetch(apiUrl, params);
  const json = (await res.json()) as PreviewDataDTO;

  if (!res.ok || json.error) {
    return {
      error: json.error ?? "quotation.split.upload.error.file.exception",
      data: { invalidQuotes: [], results: [] },
    };
  }

  return {
    data: {
      invalidQuotes: json.invalidQuotes ?? [],
      results: (json.results ?? []).map(transformPreviewItem),
    },
  };
};
